import { Component } from '@angular/core';

const TABS = {
  'ZONES': 0,
  'CATEGORIES': 1,
}

@Component({
  selector: 'app-zone-actions-drawer',
  templateUrl: './zones-drawer.component.html',
  styleUrls: ['./zones-drawer.component.scss'],
})
export class ZonesDrawerComponent {
  selectedTab = TABS.CATEGORIES;
}
